module.exports = __webpack_public_path__ + "static/media/careers-small.e49e4f1a.webp";